import '@delmonicos/shared-design-system-react/src/styles/index.scss';
import '@delmonicos/shared-design-system-react/src/styles/variables.scss';
import React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app';
import './core/locale/i18n';
import './shared/styles/index.scss';

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript -> https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-0.html#non-null-assertion-operator
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
